import { jsx as I, Fragment as b, jsxs as D } from "react/jsx-runtime";
import { c as E } from "react/compiler-runtime";
import { useEffect as N } from "react";
import { GoogleMap as R } from "@react-google-maps/api";
import { useMapContext as k } from "./MapContext.js";
import { CircularProgress as F } from "@mui/material";
import J from "./MapAddressInput.js";
import { updateMapWithPlace as U } from "./hooks.js";
import { GOOGLE_MAPS_MAP_ID as W } from "../../../config/googleMaps.js";
let G;
function ee(O) {
  const e = E(49), {
    width: s,
    height: _,
    showAddressInput: A,
    children: L,
    options: S
  } = O, {
    center: n,
    zoom: r,
    mapRef: t,
    mapType: i,
    setZoom: p,
    isAPIloaded: g,
    setMapRef: C,
    setCenter: Z,
    handleMapTypeChange: v
  } = k();
  let M;
  e[0] !== t || e[1] !== i ? (M = () => {
    if (t && i) {
      const o = t.getMapTypeId(), j = i.toLowerCase();
      o !== j && t.setMapTypeId(j);
    }
  }, e[0] = t, e[1] = i, e[2] = M) : M = e[2];
  const l = M;
  let T;
  e[3] !== l ? (T = () => {
    l();
  }, e[3] = l, e[4] = T) : T = e[4];
  let x;
  if (e[5] !== n || e[6] !== l || e[7] !== r ? (x = [l, n, r], e[5] = n, e[6] = l, e[7] = r, e[8] = x) : x = e[8], N(T, x), !g && !t) {
    let o;
    return e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ I("div", { style: {
      height: "100%",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }, children: /* @__PURE__ */ I(F, {}) }), e[9] = o) : o = e[9], o;
  }
  let a;
  e[10] !== s ? (a = {
    height: "100%",
    width: s,
    display: "flex",
    flexDirection: "column"
  }, e[10] = s, e[11] = a) : a = e[11];
  let m;
  e[12] !== g || e[13] !== t || e[14] !== Z || e[15] !== p || e[16] !== A ? (m = A && g && t && /* @__PURE__ */ I(b, { children: /* @__PURE__ */ I(J, { updatePlace: (o) => {
    U(t, o), Z(t.getCenter()?.toJSON()), p(t.getZoom());
  } }) }), e[12] = g, e[13] = t, e[14] = Z, e[15] = p, e[16] = A, e[17] = m) : m = e[17];
  let f;
  e[18] !== _ || e[19] !== s ? (f = {
    height: _,
    width: s
  }, e[18] = _, e[19] = s, e[20] = f) : f = e[20];
  let w;
  e[21] !== i ? (w = i.toLowerCase(), e[21] = i, e[22] = w) : w = e[22];
  const z = w;
  let d, c;
  e[23] !== C ? (c = (o) => {
    C(o);
  }, d = () => {
    C(void 0);
  }, e[23] = C, e[24] = d, e[25] = c) : (d = e[24], c = e[25]);
  let h;
  e[26] !== i || e[27] !== S ? (h = S || {
    mapTypeControl: !0,
    controlSize: 20,
    clickableIcons: !1,
    mapId: W,
    mapTypeId: i.toLowerCase()
  }, e[26] = i, e[27] = S, e[28] = h) : h = e[28];
  let y;
  e[29] !== l || e[30] !== t || e[31] !== p ? (y = () => {
    const o = t?.getZoom();
    o !== G && (o && p(o), G = o), l();
  }, e[29] = l, e[30] = t, e[31] = p, e[32] = y) : y = e[32];
  let u;
  e[33] !== n || e[34] !== L || e[35] !== l || e[36] !== v || e[37] !== d || e[38] !== h || e[39] !== y || e[40] !== f || e[41] !== z || e[42] !== c || e[43] !== r ? (u = /* @__PURE__ */ I(R, { mapContainerStyle: f, center: n, zoom: r, mapTypeId: z, onLoad: c, onUnmount: d, options: h, onZoomChanged: y, onCenterChanged: l, onIdle: l, onMapTypeIdChanged: v, children: L }), e[33] = n, e[34] = L, e[35] = l, e[36] = v, e[37] = d, e[38] = h, e[39] = y, e[40] = f, e[41] = z, e[42] = c, e[43] = r, e[44] = u) : u = e[44];
  let P;
  return e[45] !== u || e[46] !== a || e[47] !== m ? (P = /* @__PURE__ */ D("div", { className: "gmap", style: a, children: [
    m,
    u
  ] }), e[45] = u, e[46] = a, e[47] = m, e[48] = P) : P = e[48], P;
}
export {
  ee as default
};
